import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { catchError, Observable, of, throwError } from 'rxjs';
import { ConcurrentUsageService, LEGACY_CONCURRENT_USAGE_KEYS } from '@evorait/pace-core';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class SmartlockerStorageService {
    public readonly SMARTLOCKER_USAGE_KEY = LEGACY_CONCURRENT_USAGE_KEYS.smartlocker;

    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly concurrentUsageService: ConcurrentUsageService,
    ) {}

    public setConcurrentPreferredSmartlocker(smartlockerId: string): Observable<void> {
        return this.concurrentUsageService.writeDataForKey(this.SMARTLOCKER_USAGE_KEY, smartlockerId, Date.now()).pipe(
            map(() => undefined),
            catchError((error) => {
                this.log.error(
                    `SmartlockerStorageService: setConcurrentPreferredSmartlocker: Failed to save preferred Smartlocker. ${error}`,
                );
                return throwError(() => error);
            }),
        );
    }

    public getConcurrentPreferredSmartlocker(): Observable<string> {
        return this.concurrentUsageService.readDataForKey(this.SMARTLOCKER_USAGE_KEY).pipe(
            map((response) => {
                return response?.[0]?.value ?? '';
            }),
            catchError((error) => {
                this.log.error(
                    `SmartlockerStorageService: getConcurrentPreferredSmartlocker: Failed to retrieve preferred Smartlocker. ${error}`,
                );
                return of('');
            }),
        );
    }
}
